export const WISHLIST_ADD_ITEM = 'WISHLIST_ADD_ITEM';
export const WISHLIST_REMOVE_ITEM = 'WISHLIST_REMOVE_ITEM';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST'
export const REMOVE_FROM_WISHLIST = 'REMOVE_FROM_WISHLIST'
export const RECEIVE_WISHLIST = 'RECEIVE_WISHLIST'
export const WISHLIST_BEGIN = 'WISHLIST_BEGIN'
export const WISHLIST_END = 'WISHLIST_END'

